import $ from "jquery";

export function scrollToTop() {
    $("html, body, .el-main").animate({scrollTop: 0}, 0);
}

export function scrollTo(position, time) {
    $("html, body, .el-main").animate({scrollTop: position ? position : 0}, time ? time : 0);
}
